import { render, staticRenderFns } from "./YouTubeAuth.vue?vue&type=template&id=5541c956&scoped=true&"
import script from "./YouTubeAuth.vue?vue&type=script&lang=js&"
export * from "./YouTubeAuth.vue?vue&type=script&lang=js&"
import style0 from "./YouTubeAuth.vue?vue&type=style&index=0&id=5541c956&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5541c956",
  null
  
)

export default component.exports